import {ComponentProps} from "react";
import { useFormContext } from "react-hook-form"
import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";

export function SubmitButton({className, disabled, ...props}: ComponentProps<typeof Button>) {
    const form = useFormContext()
    const { isSubmitting } = form.formState
    return <Button
        className={cn("w-full", className)}
        loading={isSubmitting}
        type={'submit'}
        onClick={()=>form.trigger()}
        disabled={isSubmitting || disabled}
        {...props}
    />
}

SubmitButton.displayName = "SubmitButton";
